import { types } from "../types/types";

const initialState = {
  
  users: [],
  userSelected: {},
  userSelectedForPreferences: {},
  userPreferences: null,
  userSaved: {},
  userInUserRole: {},

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  usersS: [], 
  usersP: [], 
  searchTextState: "",
};
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_SELECT:
      return {
        ...state,
        userSelected: action.payload,
      };

    case types.USER_SELECT_FOR_PREFERENCES:
      return {
        ...state,
        userSelectedForPreferences: action.payload,
      };

    case types.USER_PREFERENCES_SET:
      return {
        ...state,
        userPreferences: action.payload,
      };

    case types.USER_SELECT_IN_USER_ROLE:
      return {
        ...state,
        userInUserRole: action.payload,
      };

    case types.USER_UPDATE:
      if (state.usersS.length > 0) {
        return {
          ...state,
          usersS: state.usersS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          usersP: state.usersP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          usersP: state.usersP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

      case types.USER_UPDATE_FOR_PREFERENCES:
      return {
        ...state,
        userSelectedForPreferences: action.payload,
      };

    case types.USER_DELETE:
      if (state.usersS.length > 0) {
        return {
          ...state,
          usersS: state.usersS.filter((usr) => usr.id !== action.payload),
          usersP: state.usersP.filter((usr) => usr.id !== action.payload),
          userSelected: {},
        };
      } else {
        return {
          ...state,
          usersP: state.usersP.filter((usr) => usr.id !== action.payload),
          userSelected: {},
        };
      }

    case types.USER_START_LOADING:
      return {
        ...state,
        users: action.payload,
      };

    case types.USER_START_LOADING_PAGINATED:
      return {
        ...state,
        usersP: action.payload.usersP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.USER_START_SEARCH:
      return {
        ...state,
        usersS: action.payload,
      };

    case types.USER_START_SEARCH_PAGINATED:
      return {
        ...state,
        usersS: action.payload.usersP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.USER_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        usersS: [],
      };

    case types.USER_CLEAN:
      return {
        ...state,
        userSelected: {},
      };

    case types.USER_START_REGISTER_ADMIN:
      return {
        ...state,
        userSelected: action.payload,
      };

    case types.USER_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.USER_CLEAN_USER_IN_USER_ROLE:
      return {
        ...state,
        userInUserRole: {},
      };

      case types.USER_START_REGISTER:
        return {
          ...state,
          userSaved: action.payload,
        };

        case types.USER_CLEAN_SAVED:
          return{
            ...state,
            userSaved:{}
          }

    default:
      return state;
  }
};
